import Home from "./components/Home";
import NavBar from "./components/NavBar";
import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Experience from "./components/Experience";
import Contacts from "./components/Contacts";



function App() {
  return (
    <div>
     <NavBar></NavBar>
     <Home></Home>
     <About></About>
     <SocialLinks></SocialLinks>
     <Portfolio></Portfolio>
     <Experience></Experience>
     <Contacts></Contacts>
      
    </div>

   
    );

 
   
}

export default App;
